import { get } from '../../lib/wfApi'

export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_SESSION_COOKIE = 'SET_SESSION_COOKIE'
export const SET_STORE_ID = 'SET_STORE_ID'
export const FETCH_STORE_INFO = 'FETCH_STORE_INFO'
export const FETCH_STORE_INFO_SUCCESS = 'FETCH_STORE_INFO_SUCCESS'
export const FETCH_STORE_INFO_FAILURE = 'FETCH_STORE_INFO_FAILURE'
export const FETCH_RETAILER_INFO = 'FETCH_RETAILER_INFO'
export const FETCH_RETAILER_INFO_SUCCESS = 'FETCH_RETAILER_INFO_SUCCESS'
export const FETCH_RETAILER_INFO_FAILURE = 'FETCH_RETAILER_INFO_FAILURE'

function fetchStoreNameRequest() {
  return {
    type: FETCH_STORE_INFO
  }
}

function fetchStoreNameSuccess(value) {
  return {
    type: FETCH_STORE_INFO_SUCCESS,
    payload: value
  }
}

function fetchStoreNameFailure(error) {
  return {
    type: FETCH_STORE_INFO_FAILURE,
    payload: error
  }
}

function fetchRetailerRequest() {
  return {
    type: FETCH_RETAILER_INFO
  }
}

function fetchRetailerSuccess(value) {
  return {
    type: FETCH_RETAILER_INFO_SUCCESS,
    payload: value
  }
}

function fetchRetailerFailure(error) {
  return {
    type: FETCH_RETAILER_INFO_FAILURE,
    payload: error
  }
}
 
export function setLanguage(value) {
  return {
    type: SET_LANGUAGE,
    payload: value
  }
}

export function setStoreId(value) {
  return {
    type: SET_STORE_ID,
    payload: value
  }
}

export function setSessionCookie(value) {
  return {
    type: SET_SESSION_COOKIE,
    payload: value
  }
}

export function getStoreInfo(storeId) {
  return dispatch => {
    dispatch(fetchStoreNameRequest())
    return get('stores', {}, { queryParams: { fields: escape('centre_id,name,retailer_code,_links'), store_ids: storeId }})
      .then(response => {
        return (response.ok) ? response.json() : dispatch(fetchStoreNameFailure(response.errors))
      })
      .then(data => {
        return dispatch(fetchStoreNameSuccess(data.data[0]))
      })
      .catch(() => {
        return dispatch(fetchStoreNameFailure(['error']))
      })
  }
}

export function getRetailerInfo(retailerCode) {
  return dispatch => {
    dispatch(fetchRetailerRequest())
    return get('retailers', {}, { queryParams: { fields: escape('retailer_id'), retailer_code: retailerCode }})
      .then(response => {
        return (response.ok) ? response.json() : dispatch(fetchRetailerFailure(response.errors))
      })
      .then(data => {
        return dispatch(fetchRetailerSuccess(data.data[0]))
      })
      .catch(() => {
        return dispatch(fetchRetailerFailure(['error']))
      })
  }
}